import type { VFC } from "react";

import { LoadingIndicator } from "../../shared/loading_indicator";
import { ServiceNotificationItem } from "../ServiceNotificationItem";

import type { ListServiceNotificationsQuery } from "~/client/generated/schema";
import type { SupportedLocales } from "~/client/locales";

const formattedMessage = (
  locale: SupportedLocales,
  params: {
    titleJa: string;
    titleEn?: string | null;
    messageJa: string;
    messageEn?: string | null;
    urlJa?: string | null;
    urlEn?: string | null;
  },
): { title: string; message: string; url?: string | null } => {
  const { titleJa, titleEn, messageJa, messageEn, urlJa, urlEn } = params;
  let title = titleJa;
  let message = messageJa;
  let url = urlJa;

  if (locale === "en") {
    if (titleEn != undefined && titleEn !== "") {
      title = titleEn;
    }
    if (messageEn != undefined && messageEn !== "") {
      message = messageEn;
    }
    if (urlEn != undefined && urlEn !== "") {
      url = urlEn;
    }
  }

  return { title, message, url };
};

const renderNotificationItems = (
  notifications: ListServiceNotificationsQuery["serviceNotifications"]["nodes"],
  locale: SupportedLocales,
) => {
  if (notifications.length === 0) {
    return <ServiceNotificationItem empty />;
  }

  return notifications.map((notification) => {
    const { title, message, url } = formattedMessage(locale, notification);
    return (
      <ServiceNotificationItem
        key={notification.id}
        empty={false}
        serviceNotification={{ ...notification, title, message, url }}
      />
    );
  });
};

type Props = {
  locale: SupportedLocales;
  notifications?: ListServiceNotificationsQuery["serviceNotifications"]["nodes"];
};

export const ServiceNotificationList: VFC<Props> = (props) => {
  const { notifications, locale } = props;
  return (
    <LoadingIndicator isLoaded={notifications !== undefined} top="50%" scale={0.3}>
      {notifications && renderNotificationItems(notifications, locale)}
    </LoadingIndicator>
  );
};
